// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBox_container__2og0k","input":"SearchBox_input__3XYcp","icon":"SearchBox_icon__2jKPO"};